export default "__VITE_ASSET__BfrzuAo4__"